import React from "react";

function PageBackground({ subtle = false }) {
  return (
    <>
      <div
        className={`pointer-events-none absolute inset-0 bg-hero-mesh dark:bg-hero-mesh-dark ${
          subtle ? "opacity-50 dark:opacity-40" : ""
        }`}
        aria-hidden="true"
      />
      {!subtle && (
        <>
          <div
            className="pointer-events-none absolute -right-24 top-20 h-72 w-72 rounded-full bg-brand-400/20 blur-3xl animate-float"
            aria-hidden="true"
          />
          <div
            className="pointer-events-none absolute -left-16 bottom-32 h-64 w-64 rounded-full bg-sky-400/15 blur-3xl animate-float"
            style={{ animationDelay: "2s" }}
            aria-hidden="true"
          />
        </>
      )}
    </>
  );
}

export default PageBackground;
